export default __webpack_public_path__ + "./images/mo.afeeca82.png";